export const devices_config_wave = {
	'ZW-SWITCH': {
		name: 'ShellyZwaveSwitch',
		friendly_name: 'Z-Wave Switch',
		family: 'relay',
		isPM: false,
		modes: {
			relay: {
				channels: 1,
				settings: [],
			},
		},
	},
	'ZW-COVER': {
		name: 'ShellyZwaveCover',
		friendly_name: 'Z-Wave Cover',
		family: 'roller',
		isPM: false,
		modes: {
			roller: {
				channels: 1,
				settings: [],
			},
		},
	},
	'ZW-DIMMER': {
		name: 'ShellyZwaveDimmer',
		friendly_name: 'Z-Wave Dimmer',
		family: 'light',
		isPM: false,
		modes: {
			white: {
				channels: 1,
				slider: 'brightness',
				settings: [],
			},
		},
	},
	'ZW-SENSOR': {
		name: 'ShellyZwaveSensor',
		friendly_name: 'Z-Wave Sensor',
		family: 'sensor',
		isPM: false,
		modes: {
			sensor: {
				channels: 1,
				settings: [],
			},
		},
	},
	'ZW-INPUT': {
		name: 'ShellyZwaveInput',
		friendly_name: 'Z-Wave Input',
		family: 'inputs_reader',
		isPM: false,
		modes: {
			inputs_reader: {
				channels: 4,
				settings: [],
			},
		},
	},
};
